import { ICamp } from '../model/camp.model';
import {
  AdherentCiviliteEnum,
  AlertLevelEnum,
  CampAdherentStaffRoleEnum,
  CampDiscussionSujetStatusEnum,
  CampModuleEnum,
  StatutCampEnum,
  TrancheAgeEnum,
  TypeCampEnum,
  TypeCampGroupEnum,
  TypeMossEnum,
  ValidationValueEnum
} from '../constant/enum';
import { ICampModule } from '../model/camp-module.model';
import { ICampAdherentParticipant } from '../model/camp-adherent-participant.model';
import { ICampAdherentStaff } from '../model/camp-adherent-staff.model';
import { IAdherentInformations, IAdherentQualification } from '../model/adherent-informations.model';
import moment from 'moment';
import { ICampLieu } from '../model/camp-lieu.model';
import { ICampDiscussionSujet } from '../model/camp-discussion-sujet.model';
import { ICampStructure } from '../model/camp-structure.model';
import { CampConfigurationService, ICampConfigurations } from '../service/camp-configuration.service';
import { Structure } from '../model/structure.model';
import { IDdcAlertMessge } from '../model/ddc-alert-message.model';

const validationThemes = {
  default: {classLevel: 'ddc-icon', icon: 'cancel', validationLevel: ValidationValueEnum.DEFAULT},
  info: {classLevel: 'ddc-icon-info', icon: 'check_circle', validationLevel: ValidationValueEnum.INFO},
  success: {classLevel: 'ddc-icon-success', icon: 'check_circle', validationLevel: ValidationValueEnum.SUCCESS},
  warning: {classLevel: 'ddc-icon-accent', icon: 'cancel', validationLevel: ValidationValueEnum.WARNING},
  error: {classLevel: 'ddc-icon-warm', icon: 'cancel', validationLevel: ValidationValueEnum.ERROR}
};

export interface IValidationTheme {
  classLevel?: string,
  icon?: string,
  validationLevel?: number
}

export function getCampAlertMessages(camp: ICamp) {
  if (camp && camp._campAlertMessages) return camp._campAlertMessages;
  else return [];
}

export function getValidationStatus(level: string, camp?: ICamp): IValidationTheme {
  let validationLevel: number = 0;
  switch (level) {
    case 'reglesJS':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationRegleJS : ValidationValueEnum.DEFAULT;
      break;
    case 'avisAP':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationAvisAP : ValidationValueEnum.DEFAULT;
      break;
    case 'avisRG':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationAvisRG : ValidationValueEnum.DEFAULT;
      break;
    case 'avisInternational':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationAvisInternational : ValidationValueEnum.DEFAULT;
      break;
    case 'avisMarin':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationAvisMarin : ValidationValueEnum.DEFAULT;
      break;
    case 'territoire':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationTerritoire : ValidationValueEnum.DEFAULT;
      break;
    case 'teledeclaration':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationTeledeclaration : ValidationValueEnum.DEFAULT;
      break;
    case 'etatGeneral':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationEtatGeneral : ValidationValueEnum.DEFAULT;
      break;
    case 'avisVao':
      validationLevel = camp && camp._campValidationLevels ? camp._campValidationLevels.validationAvisVao : ValidationValueEnum.DEFAULT;
      break;
    default:
      validationLevel = ValidationValueEnum.DEFAULT;
  }

  if (validationLevel === ValidationValueEnum.INFO) {
    return validationThemes.info;
  } else if (validationLevel === ValidationValueEnum.SUCCESS) {
    return validationThemes.success;
  } else if (validationLevel === ValidationValueEnum.WARNING) {
    return validationThemes.warning;
  } else if (validationLevel === ValidationValueEnum.ERROR) {
    return validationThemes.error;
  } else {
    return validationThemes.default;
  }
}

export function getReglesJSValidationLevel(camp: ICamp): number {
  const campAlertMessages = getCampAlertMessages(camp);
  if (campAlertMessages && campAlertMessages.length > 0) {
    const errors = campAlertMessages.filter((campAlertMessage: IDdcAlertMessge) => campAlertMessage.level == AlertLevelEnum.ERROR);
    const warnings = campAlertMessages.filter((campAlertMessage: IDdcAlertMessge) => campAlertMessage.level == AlertLevelEnum.WARNING);
    if (errors && errors.length > 0) {
      return ValidationValueEnum.ERROR;
    } else if (warnings && warnings.length > 0) {
      return ValidationValueEnum.WARNING;
    }
  }
  return ValidationValueEnum.SUCCESS;
}


export function getIconMarin(classLevel?: string) {
  if (classLevel) {
    return 'assets/img/' + classLevel + '-marin.png';
  }
  return 'assets/img/ddc-icon-marin.png';
}


// export function getAvisValidationLevel(camp: ICamp, typeAvis: TypeAvisEnum): number {
//   if (camp && camp.campAvis && camp.campAvis.length > 0) {
//     const avis: ICampAvis = camp.campAvis.find((avis: ICampAvis) => avis.typeAvis === typeAvis);
//     if (avis) {
//       let validationLevel = ValidationValueEnum.DEFAULT;
//       switch (typeAvis) {
//         case TypeAvisEnum.AP:
//         case TypeAvisEnum.RG:
//           if (avis.statut === StatutAvisEnum.EMIS) validationLevel = ValidationValueEnum.SUCCESS;
//           else validationLevel = ValidationValueEnum.DEFAULT;
//           break;
//         case TypeAvisEnum.MARIN:
//           if (avis.statut === StatutAvisEnum.DELIVRE) validationLevel = ValidationValueEnum.SUCCESS;
//           else if (avis.statut === StatutAvisEnum.PROJ_NAV_MODIF) validationLevel = ValidationValueEnum.WARNING;
//           else if (avis.statut === StatutAvisEnum.REFUSE) validationLevel = ValidationValueEnum.ERROR;
//           else validationLevel = ValidationValueEnum.DEFAULT;
//           break;
//         case TypeAvisEnum.INTERNATIONAL:
//         case TypeAvisEnum.VAO:
//           if (avis.statut === StatutAvisEnum.FAVORABLE || avis.statut === StatutAvisEnum.EMIS) validationLevel = ValidationValueEnum.SUCCESS;
//           else if (avis.statut === StatutAvisEnum.PREALABLE || avis.statut === StatutAvisEnum.FAVORABLE_RESERVE) validationLevel = ValidationValueEnum.WARNING;
//           else if (avis.statut === StatutAvisEnum.DEFAVORABLE) validationLevel = ValidationValueEnum.ERROR;
//           else validationLevel = ValidationValueEnum.DEFAULT;
//           break;
//         default:
//           validationLevel = ValidationValueEnum.DEFAULT;
//       }
//       return validationLevel;
//     }
//   }
//   return ValidationValueEnum.DEFAULT;
// }

// export function getTerritoireValidationLevel(camp: ICamp): number {
//   if (camp && camp.statutDepartCamp) {
//     if (camp.statutDepartCamp === StatutDepartCampEnum.VALIDE) return ValidationValueEnum.SUCCESS;
//     else if (camp.statutDepartCamp === StatutDepartCampEnum.NON_VALIDE) return ValidationValueEnum.ERROR;
//     else if (camp.statutDepartCamp === StatutDepartCampEnum.PROJ_MODIF) return ValidationValueEnum.WARNING;
//   }
//   return ValidationValueEnum.DEFAULT;
// }

// export function getTeledeclarationValidationLevel(camp: ICamp): number {
//   if (camp && camp.statutDeclarationTam) {
//     if (camp.statutDeclarationTam === StatutDeclarationEnum.PARTIAL_DECLARATION) {
//       return ValidationValueEnum.DEFAULT;
//     } else if (
//       camp.statutDeclarationTam === StatutDeclarationEnum.VALIDATED_DECLARATION
//     ) {
//       return ValidationValueEnum.SUCCESS;
//     } else if (
//       camp.statutDeclarationTam === StatutDeclarationEnum.MODIFIED_DECLARARION
//     ) {
//       return ValidationValueEnum.WARNING;
//     } else if (
//       camp.statutDeclarationTam === StatutDeclarationEnum.UNCONFIRMED_DECLARATION ||
//       camp.statutDeclarationTam === StatutDeclarationEnum.INSUFFICIENT_DECLARATION
//     ) {
//       return ValidationValueEnum.ERROR;
//     } else if (camp.statutDeclarationTam === StatutDeclarationEnum.FULL_DECLARATION) {
//       return ValidationValueEnum.INFO;
//     } else {
//       return ValidationValueEnum.DEFAULT;
//     }
//   }
//   return ValidationValueEnum.DEFAULT;
// }

export function isCampModulesActive(camp: ICamp, codeModules?: CampModuleEnum[], typeMoss?: TypeMossEnum): boolean {
  if (camp && camp.campModules && camp.campModules.length > 0) {
    if (codeModules && codeModules.length > 0) { // Check by module code
      const campModules: ICampModule[] = camp.campModules.filter((campModule: ICampModule) => codeModules.includes(campModule.module.code));
      if (campModules && campModules.length > 0) {
        let isActive: boolean = false;
        campModules.forEach((campModule: ICampModule) => {
          if (campModule.actif === true) {
            isActive = true;
          }
        });
        return isActive;
      }
    } else if (typeMoss) { // Check by category code
      const index = camp.campModules.findIndex((campModule: ICampModule) => campModule.module.typeMoss === typeMoss && campModule.actif === true);
      return index != -1 ? true : false;
    }
  }
  return false;
}

// export function getEtatGeneralDossierValidationLevel(camp: ICamp): number {
// // if the status is valid the value is 2, if not it can be 0,1,3 or 4
//   const validationTerritoire = getTerritoireValidationLevel(camp); // Autorisation depart
//   let validationAvisInternational = 0;
//   let validationAvisMarine = 0;
//
//   let validationAttributes = [];
//
//   // Initialise according the camp group
//   switch (camp.typeCamp.codeGroupeCamp) {
//     case TypeCampGroupEnum.HUIT_DIXSEPT:
//       const validationTeledeclarationTam = getTeledeclarationValidationLevel(camp); // Declaration TAM for Camp 8-17
//       validationAttributes = [validationTerritoire, validationTeledeclarationTam];
//       break;
//     case TypeCampGroupEnum.COMPAGNON:
//       validationAttributes = [validationTerritoire];
//       break;
//     case TypeCampGroupEnum.AUDACE:
//       const validationVao = getAvisValidationLevel(camp, TypeAvisEnum.VAO); // Avis VAO for camp Audace
//       validationAttributes = [validationTerritoire, validationVao];
//       break;
//     case TypeCampGroupEnum.FARFADET:
//       validationAttributes = [validationTerritoire];
//       break;
//     default:
//       validationAttributes = [];
//   }
//
//   if (isCampModulesActive(camp, [CampModuleEnum.INTERNATIONAL_8_17, CampModuleEnum.INTERNATIONAL_COMP, CampModuleEnum.ACCUEIL_ETRANGER])) {
//     validationAvisInternational = getAvisValidationLevel(camp, TypeAvisEnum.INTERNATIONAL);
//     validationAttributes.push(validationAvisInternational);
//   }
//
//   if (isCampModulesActive(camp, [CampModuleEnum.MARIN])) {
//     validationAvisMarine = getAvisValidationLevel(camp, TypeAvisEnum.MARIN);
//     validationAttributes.push(validationAvisMarine);
//   }
//
//   return calculeStatusValidationEtatGeneral(validationAttributes);
// }

// export function calculeStatusValidationEtatGeneral(validationAttributes: number[]) {
//   const item = validationAttributes.find(element => element !== ValidationValueEnum.SUCCESS);
//   return item != null ? ValidationValueEnum.ERROR : ValidationValueEnum.SUCCESS;
// }

export function getNombreCampDiscussionSujetsOuverts(camp: ICamp) {
  const campDiscussionSujetsOuverts: ICampDiscussionSujet[] =
    camp.campDiscussionSujets ?
      camp.campDiscussionSujets.filter((campDiscussionSujet: ICampDiscussionSujet) => campDiscussionSujet.statut === CampDiscussionSujetStatusEnum.OUVERTE)
      : [];
  return campDiscussionSujetsOuverts ? campDiscussionSujetsOuverts.length : 0;
}

export function getStructureOrginisatrice(camp: ICamp): Structure {
  const campStructures: ICampStructure[] = camp.campStructures;
  if (campStructures && campStructures.length > 0) {
    const campStructureOrginisatrice = campStructures.find((campStructure: ICampStructure) => campStructure.organisatrice == true);
    return campStructureOrginisatrice ? campStructureOrginisatrice.structure : null;
  }
  return null;
}

export function getStructuresParticipantes(camp: ICamp): Structure[] {
  const campStructures: ICampStructure[] = camp.campStructures;
  if (campStructures && campStructures.length > 0) {
    const structuresParticipantes =
      campStructures.filter((campStructure: ICampStructure) => campStructure.participante == true)
        .map((campStructure: ICampStructure) => campStructure.structure);
    return (structuresParticipantes && structuresParticipantes.length > 0) ? structuresParticipantes : null;
  }
  return null;
}

export function getCampMarkerClass(camp: ICamp) {
  const campConfigurations: ICampConfigurations = CampConfigurationService.getCampConfigurations(camp.typeCamp.code);
  const focusedTheme = CampConfigurationService.focusedThemeList[campConfigurations.focusedThemeIndex];
  return focusedTheme ? focusedTheme + '-column-marker' : '';
}

export function getCampLieuAddress(campLieu: ICampLieu) {
  let campLieuAddress = '';
  campLieuAddress = campLieu.libelle ? campLieu.libelle : '';
  campLieuAddress = campLieuAddress ? campLieuAddress + ' - ' + campLieu.adresseLigne1 + ', ' : '';
  if (campLieu.tamRefCommune) {
    campLieuAddress += campLieu.tamRefCommune.codePostale + ' - ' + campLieu.tamRefCommune.libelle;
  } else if (campLieu.tamRefPays) {
    campLieuAddress += campLieu.codePostal + ' - ' + campLieu.ville + ', ' + campLieu.tamRefPays.libelle;
  }
  return campLieuAddress ? campLieuAddress : 'vide';
}
export function getCampChefs (camp) {
  let campChefs: ICampAdherentStaff[] = [];

  let campAdherentStaffs: ICampAdherentStaff[] = camp.campAdherentStaffs
  campAdherentStaffs.forEach(campAdherentStaff => {
    campChefs.push(campAdherentStaff)
  })

  if(camp.campEnfants && camp.campEnfants.length > 0) {
    let campEnfants: ICamp[] = camp.campEnfants
    campEnfants.forEach(campEnfant => {
      let campEnfantStaffs: ICampAdherentStaff[] = campEnfant.campAdherentStaffs ? campEnfant.campAdherentStaffs : []
      campEnfantStaffs.forEach(campEnfantStaff => {
        campChefs.push(campEnfantStaff)
      })
    })
  }
  return campChefs;
}

export function getCampParticipants (camp) {
  let campParticipantsTotal: ICampAdherentParticipant[] = [];

  let campAdherentParticipants: ICampAdherentParticipant[] = camp.campAdherentParticipants
  campAdherentParticipants.forEach(campAdherentStaff => {
    campParticipantsTotal.push(campAdherentStaff)
  })

  if(camp.campEnfants && camp.campEnfants.length > 0) {
    let campEnfants: ICamp[] = camp.campEnfants.filter(c => c.isAttached && c.statut === StatutCampEnum.ENCOURS)
    campEnfants.forEach(campEnfant => {
      let campEnfantParticipants: ICampAdherentParticipant[] = campEnfant.campAdherentParticipants ? campEnfant.campAdherentParticipants : []
      campEnfantParticipants.forEach(campEnfantParticipant => {
        campParticipantsTotal.push(campEnfantParticipant)
      })
    })
  }
  return campParticipantsTotal;
}

export function getNbreCampAdherentParticipantsByGender(camp: ICamp, idCivilite: number) {
  let campParticipantsTotal: ICampAdherentParticipant[] = getCampParticipants(camp);

  if (camp && campParticipantsTotal && campParticipantsTotal.length > 0) {
    const campAdherentParticipants = campParticipantsTotal.filter((campAdherentParticipant: ICampAdherentParticipant) => {
      return campAdherentParticipant.adherent && campAdherentParticipant.adherent.civilite ? campAdherentParticipant.adherent.civilite.id === idCivilite : false;
    });
    return campAdherentParticipants ? campAdherentParticipants.length : 0;
  }
  return 0;
}

export function getNbreCampAdherentStaffsByGender(camp: ICamp, idCivilite: number) {
  let campChefs: ICampAdherentStaff[] = getCampChefs(camp);

  const chefsByGender = campChefs.filter((campChef: ICampAdherentStaff) => {
    return campChef.adherent && campChef.adherent.civilite ? campChef.adherent.civilite.id === idCivilite : false;
  })
  return chefsByGender ? chefsByGender.length : 0;
}

export function getNbreCampAdherentsParticipantByAge(camp: ICamp, trancheAge: string) {
  let nbreSixTreize = 0;
  let nbreQuatorzeDixSept = 0;
  let today = moment();
  let campParticipantsTotal: ICampAdherentParticipant[] = getCampParticipants(camp);

  if (camp && campParticipantsTotal && campParticipantsTotal.length > 0) {
    for (let i = 0; i < campParticipantsTotal.length; i++) {
      if (campParticipantsTotal[i].adherent.dateNaissance) {
        let age = today.diff(campParticipantsTotal[i].adherent.dateNaissance, "years");
        if (age >= 6 && age <= 13) {
          nbreSixTreize++
        } else if (age >= 14 && age <= 17) {
          nbreQuatorzeDixSept++
        }
      }
    }
  }
  return trancheAge === TrancheAgeEnum.six_treize ? nbreSixTreize : nbreQuatorzeDixSept;
}

// TODO customize the function for calculating the errors and the camp informations
export function getCampInformation(camp: ICamp) {
  let information: ICampInformation = {};

  // Structure Organisatrice
  const structureOrganisatrice = getStructureOrginisatrice(camp);
  information.structureOrganisatrice = structureOrganisatrice ? structureOrganisatrice.libelle : '';

  // Directeur
  const directors = camp && getCampChefs(camp) ?
    getCampChefs(camp).filter((campAdherentStaff: ICampAdherentStaff) => campAdherentStaff.roleStaff === CampAdherentStaffRoleEnum.DIRECTEUR) : [];
  const directorsNames = directors.map((director: ICampAdherentStaff) => `${director.adherent.prenom} ${director.adherent.nom}`);
  information.directeur = directorsNames.join('/');

  // Discussions Ouvert
  information.discussionOuvert = getNombreCampDiscussionSujetsOuverts(camp);

  // Lieu Principal
  const campLieuPrincipal = camp._isCampEnfant && camp.campPere ? camp.campPere.campLieuPrincipal : camp.campLieuPrincipal;
  const lieuPrincipal = campLieuPrincipal ? getCampLieuAddress(campLieuPrincipal) : '';
  information.lieuPrincipal = lieuPrincipal;
  information.campItinerant = camp.campLieux && camp.campLieux.length > 1 ? 'Oui' : 'Non';

  if (camp.typeCamp && (camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.HUIT_DIXSEPT || camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.AUDACE)) {
    // Jeunes
    const nbreJeunes = camp.camp817 ? camp.camp817.previsionNbre613 + camp.camp817.previsionNbre1417 : 0;
    const nbreCampAdherentParticipants = camp.campAdherentParticipants ? camp.campAdherentParticipants.length : 0;
    information.nbreJeunes = camp && getCampParticipants(camp) ? getCampParticipants(camp).length : 0
    information.nbreJeunesFilles = getNbreCampAdherentParticipantsByGender(camp, AdherentCiviliteEnum.FEMALE);
    information.nbreJeunesGarcons = getNbreCampAdherentParticipantsByGender(camp, AdherentCiviliteEnum.MALE);

    const nbreQuatorzeDixSept = camp.camp817 ? camp.camp817.previsionNbre1417 : 0;
    const nbreSixTreize = camp.camp817 ? camp.camp817.previsionNbre613 : 0;
    information.nbreQuatorzeDixSept = !!camp._isCampEnfant ? `${getNbreCampAdherentsParticipantByAge(camp, TrancheAgeEnum.quatorze_dix_sept)}` : `${getNbreCampAdherentsParticipantByAge(camp, TrancheAgeEnum.quatorze_dix_sept)} (№ déclaré: ${nbreQuatorzeDixSept.toString()})`;
    information.nbreSixTreize = !!camp._isCampEnfant ? `${getNbreCampAdherentsParticipantByAge(camp, TrancheAgeEnum.six_treize)}` : `${getNbreCampAdherentsParticipantByAge(camp, TrancheAgeEnum.six_treize)} (№ déclaré: ${nbreSixTreize.toString()})`;

    // Chefs
    information.nbreChefs = camp && getCampChefs(camp) ? getCampChefs(camp).length : 0;
    information.nbreChefsFilles = getNbreCampAdherentStaffsByGender(camp, AdherentCiviliteEnum.FEMALE);
    information.nbreChefsGarcons = getNbreCampAdherentStaffsByGender(camp, AdherentCiviliteEnum.MALE);
    // information.nbreChefsStageBafa = camp.campAdherentStaffs ? camp.campAdherentStaffs.filter((campAdherentStaff: ICampAdherentStaff) => campAdherentStaff.validationStagePratiqueBafa === true).length : 0;
    information.nbreChefsStageBafa = getCampChefs(camp) ? getCampChefs(camp).filter((campChef: ICampAdherentStaff) => campChef.validationStagePratiqueBafa === true).length : 0;
    information.nbreChefsStageBafd = getCampChefs(camp) ? getCampChefs(camp).filter((campChef: ICampAdherentStaff) => campChef.validationStagePratiqueBafd === true).length : 0;

    //Directeurs & Animateurs
    const regExpDSF = new RegExp('DSF', 'g');
    const regExpASF = new RegExp('ASF', 'g');

    let nbreDirecteursDSF = 0;
    let nbreAnimateursASF = 0;
    let nbreAnimateursASFStagiaire = 0;
    let nbreStaffsNonQualifies = 0;
    if (camp.campAdherentStaffsInformations) {
      // Directeurs
      directors.forEach((director: ICampAdherentStaff) => {
        const adherentInformations = camp.campAdherentStaffsInformations.find((campAdherentStaffInformations: IAdherentInformations) => campAdherentStaffInformations.numero === director.adherent.numero);
        const qualificationsDSF = adherentInformations && adherentInformations.adherentQualifications ?
          adherentInformations.adherentQualifications.filter((qualification: IAdherentQualification) => qualification.type.match(regExpDSF) && qualification.dateFin && moment(qualification.dateFin).diff(camp.dateFin) >= 0)
          : [];
        if (qualificationsDSF || qualificationsDSF.length > 0) {
          nbreDirecteursDSF++;
        } else {
          nbreStaffsNonQualifies++;
        }
      });

      // Animateurs
      const animateurs = getCampChefs(camp) ?
        getCampChefs(camp).filter((campAdherentStaff: ICampAdherentStaff) => campAdherentStaff.roleStaff !== CampAdherentStaffRoleEnum.DIRECTEUR) : [];
      animateurs.forEach((animateur: ICampAdherentStaff) => {
        const adherentInformations = camp.campAdherentStaffsInformations.find((campAdherentStaffInformations: IAdherentInformations) => campAdherentStaffInformations.numero === animateur.adherent.numero);
        const qualificationsASF = adherentInformations && adherentInformations.adherentQualifications ?
          adherentInformations.adherentQualifications.filter((qualification: IAdherentQualification) => qualification.type.match(regExpASF) && ((qualification.dateFin && moment(qualification.dateFin).diff(camp.dateFin) >= 0) || !qualification.dateFin))
          : [];
        if (qualificationsASF && qualificationsASF.length > 0) {
          const qualificationASFNonStagiare =
            qualificationsASF.filter((qualification: IAdherentQualification) => qualification.estTitulaire === true);
          if (qualificationASFNonStagiare && qualificationASFNonStagiare.length > 0) {
            nbreAnimateursASF++;
          } else {
            nbreAnimateursASFStagiaire++;
          }
        } else {
          nbreStaffsNonQualifies++;
        }
      });
    }
    information.nbreDirecteursDSF = nbreDirecteursDSF;
    information.nbreAnimateursASF = nbreAnimateursASF;
    information.nbreAnimateursASFStagiaire = nbreAnimateursASFStagiaire;
    information.nbreStaffsNonQualifies = nbreStaffsNonQualifies;
  } else if (camp.typeCamp && camp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.COMPAGNON) {
    const nbreCampAdherentParticipants = camp.campAdherentParticipants ? camp.campAdherentParticipants.length : 0;
    information.nbreJeunes = nbreCampAdherentParticipants;
    information.nbreJeunesFilles = getNbreCampAdherentParticipantsByGender(camp, AdherentCiviliteEnum.FEMALE);
    information.nbreJeunesGarcons = getNbreCampAdherentParticipantsByGender(camp, AdherentCiviliteEnum.MALE);

    information.nbreQuatorzeDixSept = `${getNbreCampAdherentsParticipantByAge(camp, TrancheAgeEnum.quatorze_dix_sept)}`;
    information.nbreSixTreize = `${getNbreCampAdherentsParticipantByAge(camp, TrancheAgeEnum.six_treize)}`;
  }
  return information;
}

export function isCampEnfant(camp: ICamp) {
  if (camp && camp.campPere) return true;
  return false;
}

export function isCampPere(camp: ICamp) {
  if (camp && camp.typeCamp && camp.typeCamp.code === TypeCampEnum.CAMP_ACCOMPAGNE) return true;
  return false;
}

export function cacheSpan(key, accessor: Function, dataToSpan: any[], spans: any[]) {
  for (let i = 0; i < dataToSpan.length;) {
    let currentValue = accessor(dataToSpan[i]);
    let count = 1;

    for (let j = i + 1; j < dataToSpan.length; j++) {
      if (currentValue != accessor(dataToSpan[j])) {
        break;
      }
      count++;
    }
    if (!spans[i]) {
      spans[i] = {};
    }
    spans[i][key] = count;
    i += count;
  }
}

export function getRowSpan(col, index, spans) {
  return spans[index] && spans[index][col];
}

export function isCampJumele(camp: ICamp) {
  if (camp && camp.campStructures && camp.campStructures.length > 1) return true;
  return false;
}

export interface ICampInformation {
  structureOrganisatrice?: string;
  directeur?: string;
  discussionOuvert?: number;
  lieuPrincipal?: string;
  campItinerant?: string;
  nbreJeunes?: number;
  nbreJeunesFilles?: number;
  nbreJeunesGarcons?: number;
  nbreChefs?: number;
  nbreChefsFilles?: number;
  nbreChefsGarcons?: number;
  nbreChefsStageBafa?: number;
  nbreChefsStageBafd?: number;
  nbreDirecteursDSF?: number;
  nbreAnimateursASF?: number;
  nbreAnimateursASFStagiaire?: number;
  nbreStaffsNonQualifies?: number;
  nbreSixTreize?: string;
  nbreQuatorzeDixSept?: string;
}
